module.exports = __webpack_public_path__ + "img/7valvulas.714ef6b8.jpg";